import { gql } from '@apollo/client';

export const REGION_FRAGMENT = gql`
  fragment Region on RegionOutput {
    id
    createdAt
    updatedAt
    name
    idexxAccountNumber
    zoetisAccountNumber
  }
`;

export const OFFICE_FRAGMENT = gql`
  fragment Office on OfficeOutput {
    id
    createdAt
    updatedAt
    name
    idexxAccountNumber
    zoetisAccountNumber
    region {
      ...Region
    }
  }
  ${REGION_FRAGMENT}
`;

export const LOCATION_FRAGMENT = gql`
  fragment Location on LocationOutput {
    id
    createdAt
    updatedAt
    name
    type
    region {
      ...Region
    }
  }
  ${REGION_FRAGMENT}
`;
